export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YOZqilss6yLUrwA.82953a8f.woff2";